"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Signature_1 = require("components/Signature");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var validations_1 = require("lib/functions/validations");
var rules = {
    signature_confirmation: validations_1.mandatory
};
var ApplicationSignatureForm = (function (_super) {
    __extends(ApplicationSignatureForm, _super);
    function ApplicationSignatureForm(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Object.defineProperty(ApplicationSignatureForm.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    ApplicationSignatureForm.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    ApplicationSignatureForm.prototype.onChange = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Id", id);
                console.log("Value", value);
                this.json_data[id] = value;
                this.forceUpdate();
                return [2];
            });
        });
    };
    ApplicationSignatureForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("ApplicationSignatureForm validateApplication", this.isValid);
                return [2];
            });
        });
    };
    ApplicationSignatureForm.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("ApplicationSignatureForm validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    ApplicationSignatureForm.prototype.isValid = function () {
        console.log("Validate ApplicationSignatureForm");
        var json_data = this.props.model.json_data;
        var specialRules = rules;
        var _a = findErrors_1.findErrors(this.json_data, specialRules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", this.errors);
        return isValid;
    };
    ApplicationSignatureForm.prototype.render = function () {
        var model = this.props.model;
        var json_data = model.json_data;
        return (React.createElement("div", null,
            React.createElement("section", { className: "section-content scw" },
                React.createElement("h2", { className: "section-title-spa" }, "Applicant signature"),
                React.createElement("article", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement(Signature_1.Signature, { id: "signature_confirmation", onChange: this.onChange, model: this.props.model, errors: this.errors })))))));
    };
    __decorate([
        mobx_1.observable
    ], ApplicationSignatureForm.prototype, "errors", void 0);
    ApplicationSignatureForm = __decorate([
        mobx_react_1.observer
    ], ApplicationSignatureForm);
    return ApplicationSignatureForm;
}(react_1.Component));
exports.ApplicationSignatureForm = ApplicationSignatureForm;
//# sourceMappingURL=data:application/json;base64,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